import 'css/common.css'
import { PresentationStatusPage, PayAttentionPage, DoneEarlyPage, TeacherInterruptionPage, CorrectAnswerPage, IncorrectAnswerPage } from '../components/presentation-status-page'

export const ComponentStaging = () => {
    return (
        <>
            <PresentationStatusPage blueText="Blue Text" blackText="Black Text" />
            <PayAttentionPage />
            <DoneEarlyPage />
            <TeacherInterruptionPage />
            <CorrectAnswerPage />
            <IncorrectAnswerPage />
        </>
    )
}